import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { GlobalSpinnerService } from '../../../../shared/components/loader-service/global-spinner.service';
import { Principal } from '../../../../shared/auth/principal.service';
import { SnackBarService } from '../../../../shared/services/snackbar.service';
import { ANPublisher } from '../../domain/dp-integration/an-publisher.model';
import { CreateAppNexusAdUnitRequest, DpConnectorsService } from '../../services/dp-connectors.service';
import { ANSite } from '../../domain/dp-integration/an-site.model';
import { SortUtils } from '../../../../shared/utils/sort-utils';
import { AdStatsWidgetTypesService } from '../../../../shared/services/ad-stats-widget-types.service';
import { BridgeAdUnit } from '../../../../shared/domain/bridge-ad-unit.model';

@Component({
  selector: 'cm-kn-dp-autocreation-appnexus-dialog.component',
  templateUrl: `./dp-autocreation-appnexus-dialog.component.html`,
  styles: [`
    ::ng-deep .mat-tab-label {
      flex: 1;
    }
    
    ::ng-deep .appnexus-dialog .mat-tab-header {
      margin: 0 -24px 16px;
    }

    /* Required for mobile view*/
    ::ng-deep .appnexus-dialog .mat-dialog-content {
      max-height: none;
    }
  `]

})
export class DpAutocreationAppnexusDialogComponent {

  publisher: ANPublisher = new ANPublisher();
  publisherList: ANPublisher[] = [];
  siteList: ANSite[] = [];
  unitRequest: CreateAppNexusAdUnitRequest = new CreateAppNexusAdUnitRequest();

  siteRequest: { publisherId?: string, name?: string } = {};
  availableWidgetSizes: string[];

  adUnit: BridgeAdUnit;

  constructor(public dialogRef: MatDialogRef<DpAutocreationAppnexusDialogComponent>,
              private gss: GlobalSpinnerService,
              private principal: Principal,
              private service: DpConnectorsService,
              private widgetTypesService: AdStatsWidgetTypesService,
              private sbs: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.adUnit = data.adUnit;
    this.unitRequest.name = this.adUnit.name;
    this.refreshPublisherList();
    this.widgetTypesService.getAll().subscribe(widgetTypes => {
      this.availableWidgetSizes = Array.from(new Set(widgetTypes.map(type => type.adWidth + 'x' + type.adHeight)));
      this.availableWidgetSizes.sort();
      const found = widgetTypes.find(t => t.name === this.adUnit.widgetName);
      if (found) {
        this.unitRequest._size = found.adWidth + 'x' + found.adHeight;
      }
    });
  }

  createPublisher() {
    this.gss.showLoader();
    this.service.appnexusPublisherPost(this.publisher).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.error('Publisher created successfully in appnexus');
      this.publisher = new ANPublisher();
      this.refreshPublisherList();
    }, () => {
      this.gss.hideLoader();
      this.sbs.error('Error during appnexus publisher creation');
    });
  }

  createUnit() {
    this.gss.showLoader();
    this.unitRequest.width = Number(this.unitRequest._size.split('x')[0]);
    this.unitRequest.height = Number(this.unitRequest._size.split('x')[1]);
    this.service.appnexusAdUnitPost(this.unitRequest).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.error('Ad unit created successfully in appnexus');
      this.dialogRef.close(true);
    }, () => {
      this.gss.hideLoader();
      this.sbs.error('Error during appnexus ad unit creation');
    });
  }

  createSite() {
    this.gss.showLoader();
    this.service.appnexusSitePost(this.siteRequest).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.error('Site created successfully in appnexus');
      this.siteRequest = {};
      if (this.unitRequest.publisherId) {
        this.onPublisherSelected(this.unitRequest.publisherId);
      }
    }, () => {
      this.gss.hideLoader();
      this.sbs.error('Error during appnexus site creation');
    });
  }

  refreshPublisherList() {
    this.service.appnexusPublisherGet().subscribe(next => {
      this.publisherList = next;
      this.publisherList.sort(SortUtils.propertyComparatorString('name'));
      const found = this.publisherList.find(p => p.name.toLowerCase() === this.adUnit.publisher.name.toLowerCase());
      if (found) {
        this.unitRequest.publisherId = found.id;
        this.siteRequest.publisherId = found.id;
        this.onPublisherSelected(found.id);
      }
    });
  }

  onPublisherSelected(pubId: string) {
    this.service.appnexusSiteGet(pubId).subscribe(next => {
      this.siteList = next;
    });
  }

}
